<div class="payment-history-dialog">
  <div class="dialog-header">
    <h2>Histórico de Pagos</h2>
  </div>

  <div class="dialog-content">
    <div *ngIf="paymentHistory && paymentHistory.length > 0; else noPayments">
      <div class="table-container">
        <table class="payment-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Cantidad</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let invoice of pagedHistory; trackBy: trackByIndex" class="invoice-row">
              <td>
                <span class="invoice-date">{{ invoice.createdAt | date:'d \'de\' MMMM, y' }}</span>
              </td>
              <td>
                <span class="invoice-amount">{{ invoice.amount | number:'1.2-2' }}{{ invoice.currency ? ' ' + invoice.currency.toUpperCase() : '' }}</span>
              </td>
              <td>
                <span class="invoice-status" [ngClass]="getStatusClass(invoice.status)">
                  {{ getStatusLabel(invoice.status) }}
                </span>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-controls" *ngIf="totalPages > 1">
        <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">‹ Anterior</button>
        <span class="page-info">Página {{ currentPage }} de {{ totalPages }}</span>
        <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)">Siguiente ›</button>
      </div>
    </div>

    <ng-template #noPayments>
      <div class="no-payments">
        <mat-icon>receipt</mat-icon>
        <p>No hay pagos en el histórico</p>
      </div>
    </ng-template>
  </div>

  <div class="dialog-footer">
    <button type="button" class="btn-factuone" (click)="closeDialog()">Cerrar</button>
  </div>
</div>
